import type { FormValidationController } from "@/modules/formValidation";

export async function runConfirmedDelete(
  validation: FormValidationController,
  onDelete: () => void,
): Promise<void> {
  // Delete handlers commonly navigate after their mutation. Make the form clean before handing
  // control to them so route-leave protection does not treat the confirmed delete as an attempt
  // to discard unrelated edits.
  await validation.commitAllBaselines();
  onDelete();
}
